<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-dialog v-model="dialog.success"
          width="350">
          <v-card 
            class="border-radius pa-2">
            <v-card-text>
              <v-img 
                width="125"
                height="125"
                alt="tvandroid" 
                :src="require('@/assets/icon/info_berhasil.png')"
                class="ma-auto my-6">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      size="20"
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>

              <div
                class="body-1 text-center line-text-second">
                <div>
                  Thank you, your custom data
                </div>

                <div>
                  has been successfully changed!
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                @click="$router.go(-1)"
                flat
                color="transparent"
                style="width: 15%;">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="26"
                      style="opacity: 30%;">
                      <v-img
                        contain
                        alt="tvandroid"  
                        :src="require('@/assets/icon/back_arrow.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Guest Room
                    </span>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <div v-if="process.load && Object.keys(detail).length < 1">
            <v-row
              class="pa-4 pr-1">
              <v-col
                cols="12"
                md="3">
                <v-skeleton-loader
                  :loading="process.load"
                  type="article">
                </v-skeleton-loader>
              </v-col>

              <v-col
                cols="12"
                md="3">
                <v-skeleton-loader
                  :loading="process.load"
                  type="article">
                </v-skeleton-loader>
              </v-col>

              <v-col
                cols="12"
                md="3">
                <v-skeleton-loader
                  :loading="process.load"
                  type="article">
                </v-skeleton-loader>
              </v-col>

              <v-col
                cols="12"
                md="3">
                <v-skeleton-loader
                  :loading="process.load"
                  type="article">
                </v-skeleton-loader>
              </v-col>
            </v-row>

            <v-skeleton-loader
              :loading="process.load"
              type="list-item-two-line">
            </v-skeleton-loader>

            <v-row>
              <v-col
                cols="12"
                md="6">
                <v-skeleton-loader
                  :loading="process.load"
                  type="article">
                </v-skeleton-loader>
              </v-col>

              <v-col
                cols="12"
                md="6">
                <v-skeleton-loader
                  :loading="process.load"
                  type="article">
                </v-skeleton-loader>
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
                md="6">
                <v-skeleton-loader
                  :loading="process.load"
                  type="article">
                </v-skeleton-loader>
              </v-col>

              <v-col
                cols="12"
                md="6">
                <v-skeleton-loader
                  :loading="process.load"
                  type="article">
                </v-skeleton-loader>
              </v-col>
            </v-row>
          </div>

          <div v-if="!process.load && Object.keys(detail).length > 0">
            <v-row
              class="pa-4 pr-1">
              <v-col 
                cols="12"
                class="py-0">
                <v-card 
                  flat
                  style="border-radius: 10px; border: 1px solid #E7E7E7;">
                  <v-card-text
                    class="px-6">
                    <v-row>
                      <v-col
                        cols="12"
                        md="2">
                        <v-card
                          flat
                          color="#EDEDED"
                          min-height="107"
                          class="text-h2 font-weight-bold d-flex align-center justify-center"
                          style="border: 1px solid #D8D8D8; border-radius: 8px; padding: 23px;">
                          <div
                            style="opacity: 90%;">
                            {{ detail.number }}
                          </div>
                        </v-card>
                      </v-col>

                      <v-col
                        cols="12"
                        md="4">
                        <v-card
                          flat
                          color="#F9F9F9"
                          style="border: 1px solid #D8D8D8; border-radius: 8px;">
                          <div
                            class="d-flex align-center">
                            <div
                              style="border-right: 1px solid #D8D8D8; width: 40%;">
                              <v-card
                                flat
                                color="#EDEDED"
                                class="body-2 font-weight-bold pa-4"
                                style="opacity: 70%;">
                                Customer
                              </v-card>

                              <v-divider
                              style="border-top: 1px solid #D8D8D8;"/>

                              <v-card
                                flat
                                color="#EDEDED"
                                class="body-2 font-weight-bold pa-4"
                                style="opacity: 70%;">
                                Phone
                              </v-card>
                            </div>

                            <div
                              style="width: 60%;">
                              <v-card
                                flat
                                color="transparent"
                                class="body-2 pa-4"
                                style="opacity: 70%;">
                                {{ detail.guest_name }}
                              </v-card>

                              <v-divider
                              style="border-top: 1px solid #D8D8D8;"/>

                              <v-card
                                flat
                                color="transparent"
                                class="body-2 pa-4"
                                style="opacity: 70%;">
                                {{ detail.guest_phone_number }}
                              </v-card>
                            </div>
                          </div>
                        </v-card>
                      </v-col>

                      <v-col
                        cols="12"
                        md="3">
                        <v-card
                          flat
                          color="#F9F9F9"
                          style="border: 1px solid #D8D8D8; border-radius: 8px;">
                          <div
                            class="d-flex align-center">
                            <div
                              style="border-right: 1px solid #D8D8D8; width: 40%;">
                              <v-card
                                flat
                                color="#EDEDED"
                                class="body-2 font-weight-bold pa-4"
                                style="opacity: 70%;">
                                Check In
                              </v-card>

                              <v-divider
                              style="border-top: 1px solid #D8D8D8;"/>

                              <v-card
                                flat
                                color="#EDEDED"
                                class="body-2 font-weight-bold pa-4"
                                style="opacity: 70%;">
                                Check Out
                              </v-card>
                            </div>

                            <div
                              style="width: 60%;">
                              <v-card
                                flat
                                color="transparent"
                                class="body-2 pa-4"
                                style="opacity: 70%;">
                                {{ detail.guest_checkin_datetime | date }} - {{ detail.guest_checkin_datetime | time }}
                              </v-card>

                              <v-divider
                              style="border-top: 1px solid #D8D8D8;"/>

                              <v-card
                                flat
                                color="transparent"
                                class="body-2 pa-4"
                                style="opacity: 70%;">
                                {{ detail.guest_checkout_datetime | date }} - {{ detail.guest_checkout_datetime | time }}
                              </v-card>
                            </div>
                          </div>
                        </v-card>
                      </v-col>

                      <v-col
                        cols="12"
                        md="3">
                        <v-card
                          flat
                          color="#F9F9F9"
                          style="border: 1px solid #D8D8D8; border-radius: 8px;">
                          <div
                            class="d-flex align-center">
                            <div
                              style="border-right: 1px solid #D8D8D8; width: 50%;">
                              <v-card
                                flat
                                color="#EDEDED"
                                class="body-2 font-weight-bold pa-4"
                                style="opacity: 70%;">
                                Status
                              </v-card>

                              <v-divider
                              style="border-top: 1px solid #D8D8D8;"/>

                              <v-card
                                flat
                                color="#EDEDED"
                                class="body-2 font-weight-bold pa-4"
                                style="opacity: 70%;">
                                Wake up Time
                              </v-card>
                            </div>

                            <div
                              style="width: 50%;">
                              <v-card
                                flat
                                color="transparent"
                                class="body-2 pa-4"
                                style="opacity: 70%;">
                                {{ detail.status }}
                              </v-card>

                              <v-divider
                              style="border-top: 1px solid #D8D8D8;"/>

                              <v-card
                                flat
                                color="transparent"
                                class="body-2 pa-4"
                                style="opacity: 70%;">
                                {{ detail.wake_up_call }}
                              </v-card>
                            </div>
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row
              class="px-4">
              <v-col
                cols="12">
                <v-expansion-panels
                  flat>
                  <v-expansion-panel
                    style="border-radius: 10px; border: 1px solid #E7E7E7;">
                    <v-expansion-panel-header
                      class="body-2 font-weight-bold">
                      Custom Check Out
                    </v-expansion-panel-header>

                    <v-expansion-panel-content>
                      <ValidationObserver 
                        ref="form_checkout">
                        <v-row>
                          <v-col
                            cols="12"
                            md="6"
                            class="py-0">
                            <div>
                              <div class="body-2 mb-2">
                                <span class="red--text">*</span>

                                Check Out
                              </div>

                              <v-menu
                                ref="dateend"
                                min-width="290px"
                                max-width="290px"
                                transition="scale-transition"
                                offset-y
                                :nudge-right="40"
                                :close-on-content-click="false"
                                v-model="picker.end">
                                <template v-slot:activator="{ on, attrs }">
                                  <ValidationProvider 
                                    name="Check Out" 
                                    rules="required" 
                                    v-slot="{ errors, valid }">
                                    <v-text-field
                                      v-on:keyup.enter="save()"
                                      
                                      v-on="on"
                                      v-bind="attrs"
                                      
                                      filled
                                      rounded
                                      dense

                                      :color="set_color"
                                      placeholder="Ex : 2023-10-13"
                                      :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                                      clearable
                                      @click:clear="form_checkout.end_date = ''"

                                      v-model="form_checkout.end_date"
                                      :success="valid"
                                      :error-messages="errors"
                                      required
                                      style="border-radius: 10px;">
                                    </v-text-field>
                                  </ValidationProvider>
                                </template>

                                <v-date-picker 
                                  :color="set_color"
                                  :min="form_checkout.start_date"
                                  v-model="form_checkout.end_date"
                                  @input="picker.end = false">
                                </v-date-picker>
                              </v-menu>
                            </div>
                          </v-col>

                          <v-col
                            cols="12"
                            md="5"
                            class="py-0">
                            <div>
                              <div class="body-2 mb-2">
                                <span class="red--text">*</span>

                                Check Out Time
                              </div>

                              <v-menu
                                ref="timeend"
                                v-model="time.end"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="form_checkout.end_time"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                  <ValidationProvider 
                                    name="Check Out Time" 
                                    rules="required" 
                                    v-slot="{ errors, valid }">
                                    <v-text-field
                                      v-on:keyup.enter="save()"
                                      
                                      v-on="on"
                                      v-bind="attrs"
                                      
                                      filled
                                      rounded
                                      dense

                                      :color="set_color"
                                      placeholder="Ex : 13:00"
                                      :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                                      clearable
                                      @click:clear="form_checkout.end_time = ''"

                                      v-model="form_checkout.end_time"
                                      :success="valid"
                                      :error-messages="errors"
                                      required
                                      style="border-radius: 10px;">
                                    </v-text-field>
                                  </ValidationProvider>
                                </template>

                                <v-time-picker
                                  v-if="time.end"
                                  v-model="form_checkout.end_time"
                                  full-width
                                  :color="set_color"
                                  format="24hr"
                                  @click:minute="$refs.timeend.save(`${form_checkout.end_time}:00`)">
                                </v-time-picker>
                              </v-menu>
                            </div>
                          </v-col>

                          <v-col
                            cols="12"
                            md="1"
                            class="py-0">
                            <v-btn
                              @click="save_checkout()"
                              :loading="process.form_checkout"
                              :disabled="process.form_checkout || process.reset"
                              block
                              color="#4B4B4B"
                              elevation="0"
                              class="body-2 white--text text-capitalize"
                              style="border-radius: 8px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1)); margin-top: 28px;">
                              Save
                            </v-btn>
                          </v-col>
                        </v-row>
                      </ValidationObserver>

                      <div v-if="message.error.length > 0"
                        class="text-center my-4 d-flex align-center">
                        <div
                          class="error--text">
                          <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                          
                          <span
                            class="ml-1">
                            {{ message.error }}
                          </span>
                        </div>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>

            <v-row
              class="px-4">
              <v-col
                cols="12">
                <v-expansion-panels
                  flat>
                  <v-expansion-panel
                    style="border-radius: 10px; border: 1px solid #E7E7E7;">
                    <v-expansion-panel-header
                      class="body-2 font-weight-bold">
                      Custom Data
                    </v-expansion-panel-header>

                    <v-expansion-panel-content>
                      <ValidationObserver 
                        ref="form">
                        <v-form>
                          <v-row>
                            <v-col
                              cols="12"
                              md="2">
                              <div
                              class="body-2 mb-2"
                              style="opacity: 70%;">
                              Guest Photo
                              </div>

                              <folder v-if="form.guest_image_url === ''"
                                v-model="upload.folder">
                                <div 
                                  slot="activator">
                                  <v-card 
                                    flat
                                    width="100%"
                                    height="176"
                                    class="d-flex align-center justify-center cursor-pointer"
                                    style="border-radius: 10px;
                                          border: 2px solid #EBEBEB; 
                                          border-style: dashed;">
                                    <v-avatar v-if="!process.file"
                                      v-ripple
                                      tile 
                                      width="100%"
                                      height="176">
                                      <v-icon
                                        size="50"
                                        color="#B9B9B9">
                                        mdi-cloud-upload-outline
                                      </v-icon>
                                    </v-avatar>

                                    <v-progress-circular v-else
                                      indeterminate
                                      :color="set_color">
                                    </v-progress-circular>
                                  </v-card>
                                </div>
                              </folder>

                              <v-card v-if="form.guest_image_url !== ''"
                                flat
                                width="100%"
                                height="176"
                                class="d-flex align-center justify-center"
                                style="border-radius: 10px;
                                      border: 2px solid #EBEBEB; 
                                      border-style: dashed;">
                                <v-avatar v-if="!process.file"
                                  v-ripple
                                  tile 
                                  width="100%"
                                  height="176">
                                  <v-img 
                                    contain
                                    width="100%"
                                    height="100%"
                                    alt="tvandroid" 
                                    :src="form.guest_image_url"
                                    class="ma-auto">
                                    <template v-slot:placeholder>
                                      <v-row
                                        class="fill-height"
                                        align="center"
                                        justify="center">
                                        <v-progress-circular 
                                          indeterminate 
                                          :color="set_color">
                                        </v-progress-circular>
                                      </v-row>
                                    </template>
                                  </v-img>
                                </v-avatar>

                                <v-icon 
                                  @click="form.guest_image_url = ''"
                                  color="red"
                                  class="cursor-pointer"
                                  style="position: absolute; top: -10px; right: -10px;">
                                  mdi-close-circle
                                </v-icon>
                              </v-card>
                            </v-col>

                            <v-col
                              cols="12"
                              md="9">
                              <div>
                                <div class="body-2 mb-2">
                                  <span class="red--text">*</span>

                                  <span
                                    style="opacity: 70%;">
                                    Custom Welcome Guest
                                  </span>
                                </div>

                                <div
                                  class="body-2 mb-4"
                                  style="opacity: 70%;">
                                  Please use the variable <strong style="font-weight: bold !important;">%%guest_name%%</strong> to display the guest name on the TV platform.
                                </div>

                                <quill-editor 
                                  ref="myTextEditor"
                                  :options="{
                                    placeholder: 'Ex : Selamat datang di Visuality - Semoga perjalanan anda berkesan bersama kami - Tetap patuhi protokol kesehatan - Follow IG kami di @Visuality untuk mengetahui promo promo terbaru kami.'
                                  }"
                                  v-model="form.guest_welcome_text_html">
                                </quill-editor>
                              </div>
                              
                              <!-- <ValidationProvider 
                                name="Custom Welcome Guest" 
                                rules="max:256"
                                v-slot="{ errors, valid }">
                                <div 
                                  class="body-2 mb-2"
                                  style="opacity: 70%;">
                                  Custom Welcome Guest
                                </div>

                                <v-textarea
                                  filled
                                  rounded
                                  dense
                                  rows="6"

                                  :color="set_color"
                                  placeholder="Ex : Selamat datang di Visuality - Semoga perjalanan anda berkesan bersama kami - Tetap patuhi protokol kesehatan - Follow IG kami di @Visuality untuk mengetahui promo promo terbaru kami."
                                  :append-icon="valid && form.guest_welcome_text !== '' ? 'mdi-check-circle-outline' : ''"

                                  v-model="form.guest_welcome_text"
                                  :success="valid && form.guest_welcome_text !== ''"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-textarea>
                              </ValidationProvider> -->
                            </v-col>

                            <v-col
                              cols="12"
                              md="1">
                              <v-btn
                                @click="save()"
                                :loading="process.form"
                                :disabled="process.form || process.reset"
                                block
                                color="#4B4B4B"
                                elevation="0"
                                class="body-2 white--text text-capitalize"
                                style="border-radius: 8px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1)); margin-top: 28px;">
                                Save
                              </v-btn>

                              <!-- <v-btn
                                @click="reset()"
                                :loading="process.reset"
                                :disabled="process.reset || process.form"
                                block
                                color="#4B4B4B"
                                elevation="0"
                                class="body-2 white--text text-capitalize mt-4"
                                style="border-radius: 8px; font-weight: 600; background: linear-gradient(rgb(211 99 95), rgb(192, 62, 58));">
                                Reset
                              </v-btn> -->
                            </v-col>
                          </v-row>
                        </v-form>
                      </ValidationObserver>

                      <div v-if="message.error.length > 0"
                        class="text-center my-4 d-flex align-center">
                        <div
                          class="error--text">
                          <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                          
                          <span
                            class="ml-1">
                            {{ message.error }}
                          </span>
                        </div>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>

            <v-row
              class="py-3 px-4 pr-1">
              <v-col 
                cols="12"
                class="py-0">
                <v-row>
                  <v-col
                    cols="12"
                    md="6">
                    <div
                      class="body-1 font-weight-bold mb-3">
                      Today Food Order
                    </div>

                    <div
                      v-for="(item, index) in detail.today_food_order"
                      :key="index"
                      :class="index < detail.today_food_order.length - 1 ? 'mb-5' : ''">
                      <v-card 
                        flat
                        style="border-radius: 10px; border: 1px solid #E7E7E7;">
                        <v-card-text
                          class="px-6">
                          <div
                            class="d-flex align-center">
                            <div
                              class="body-2 primary--text">
                              {{ item.datetime | date }} - {{ item.datetime | time }}
                            </div>

                            <v-spacer />

                            <v-chip
                              small
                              rounded
                              :color="item.status === 'waiting' ? 'yellow' : item.status === 'void' ? '#C03E3A' : set_color"
                              elevation="0"
                              class="text-capitalize mx-1 d-flex justify-center"
                              :class="item.status === 'waiting' ? '' : 'white--text'"
                              style="font-weight: 600; width: 80px;">
                              {{ item.status }}
                            </v-chip>
                          </div>

                          <v-divider 
                            class="my-4"
                            style="border-top: 2px dashed #e0e0e0;"/>

                          <v-simple-table 
                            dense>
                            <template v-slot:default>
                              <tbody>
                                <tr
                                  v-for="(item_sub, index_sub) in item.detail"
                                  :key="index_sub">
                                  <td width="225" style="border: none !important;" class="pl-0">{{ item_sub.menu_name }}</td>
                                  <td style="border: none !important;">{{ item_sub.qty }} x {{ item_sub.price | price }}</td>
                                  <td style="border: none !important;" class="text-right pr-0">{{ item_sub.subtotal | price }}</td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>

                          <v-divider 
                            class="my-4"
                            style="border-top: 2px dashed #e0e0e0;"/>

                          <div
                            class="body-1 font-weight-bold text-right black--text">
                            <span
                              class="body-2 mr-6">
                              Total
                            </span>

                            {{ item.total_bill | price }}
                          </div>
                        </v-card-text>
                      </v-card>
                    </div>

                    <v-card
                      v-if="detail.today_food_order.length < 1"
                      flat
                      color="transparent"
                      class="pa-4 d-flex align-center"
                      style="border: 2px dashed #e0e0e0 !important; border-radius: 10px;">
                      <v-icon>mdi-progress-alert</v-icon>
                      
                      <span
                        class="ml-2">
                        No food order today
                      </span>
                    </v-card>
                  </v-col>

                  <v-col
                    cols="12"
                    md="6">
                    <div
                      class="body-1 font-weight-bold mb-3">
                      Today Services Request
                    </div>

                    <div
                      v-for="(item, index) in detail.today_service_request"
                      :key="index"
                      :class="index < detail.today_service_request.length - 1 ? 'mb-5' : ''">
                      <v-card 
                        flat
                        style="border-radius: 10px; border: 1px solid #E7E7E7;">
                        <v-card-text
                          class="px-6">
                          <div
                            class="d-flex align-center">
                            <div
                              class="body-2 primary--text">
                              {{ item.datetime | date }} - {{ item.datetime | time }}
                            </div>

                            <v-spacer />

                            <v-chip
                              small
                              rounded
                              :color="item.status === 'waiting' ? 'yellow' : item.status === 'void' ? '#C03E3A' : set_color"
                              elevation="0"
                              class="text-capitalize mx-1 d-flex justify-center"
                              :class="item.status === 'waiting' ? '' : 'white--text'"
                              style="font-weight: 600; width: 80px;">
                              {{ item.status }}
                            </v-chip>
                          </div>

                          <v-divider 
                            class="my-4"
                            style="border-top: 2px dashed #e0e0e0;"/>

                          <v-simple-table 
                            dense>
                            <template v-slot:default>
                              <tbody>
                                <tr>
                                  <td width="225" style="border: none !important;" class="pl-0">{{ item.type.replace(/_/g, ' ') }}</td>
                                  <td style="border: none !important;" class="text-right pr-0">{{ item.wake_up_time }}</td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>

                          <div v-if="item.detail !== '' && item.detail !== null "
                            class="body-2 black--text px-1 mb-6">
                            {{ item.detail }}
                          </div>

                          <v-divider 
                            class="my-4"
                            style="border-top: 2px dashed #e0e0e0;"/>
                        </v-card-text>
                      </v-card>
                    </div>

                    <v-card
                      v-if="detail.today_service_request.length < 1"
                      flat
                      color="transparent"
                      class="pa-4 d-flex align-center"
                      style="border: 2px dashed #e0e0e0 !important; border-radius: 10px;">
                      <v-icon>mdi-progress-alert</v-icon>
                      
                      <span
                        class="ml-2">
                        No services request today
                      </span>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        dialog: {
          success: false
        },

        detail: {},

        form: {
          id: '',
          guest_image_url: '',
          guest_welcome_text: '',
          guest_welcome_text_html: ''
        },

        picker: {
          end: false
        },

        time: {
          end: false
        },

        form_checkout: {
          id: '',
          guest_checkin_datetime: '',
          guest_checkout_datetime: '',

          start_date: '',
          end_date: '',

          end_time: '',
          end_time: ''
        },

        upload: {
          folder: null
        },

        process: {
          load: false,

          form: false,

          reset: false,

          file: false,
          form_checkout: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      folder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.folder': {
        handler: function () {
          if (this.upload.folder) {
            this.process.file = this.upload.folder.process

            if (!this.process.file) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.form.guest_image_url = this.upload.folder.file_url
            }
          }
        },
        deep: true
      },

      'form.guest_welcome_text_html': function (val) {
        this.form.guest_welcome_text = val.replace(/<[^>]*>/g, '').replace(/[^\w\s]/gi, '')
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.process.load = true

        let params = {
          id: this.$route.params.id
        }

        await get(`admin/guest-room/detail`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          if (res.code === 200) {
            this.detail = res.result

            this.form = {
              id: res.result.id,
              guest_image_url: res.result.guest_image_url,
              guest_welcome_text: res.result.guest_welcome_text,
              guest_welcome_text_html: res.result.guest_welcome_text_html
            }

            this.form_checkout = {
              id: res.result.id,
              guest_checkout_datetime: res.result.guest_checkout_datetime,
              guest_checkin_datetime: res.result.guest_checkin_datetime,

              start_date: res.result.guest_checkin_datetime.split(' ')[0],
              end_date: res.result.guest_checkout_datetime.split(' ')[0],
              start_time: res.result.guest_checkin_datetime.split(' ')[1],
              end_time: res.result.guest_checkout_datetime.split(' ')[1]
            }
          }
        })
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/guest-room/update-custom-data`, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.code === 200) {
              this.dialog.success = true
            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      async save_checkout () {
        this.message.error = ''

        const isValid = await this.$refs.form_checkout.validate()
        if (isValid) {
          this.process.form_checkout = true

          this.form_checkout.guest_checkin_datetime = `${this.form_checkout.start_date} ${this.form_checkout.start_time}`
          this.form_checkout.guest_checkout_datetime = `${this.form_checkout.end_date} ${this.form_checkout.end_time}`

          // SAVE TO REST API
          await post(`admin/guest-room/update-checkout`, {
            data: this.form_checkout
          })
          .then((response) => {
            let res = response.data

            this.process.form_checkout = false

            if (res.code === 200) {
              this.dialog.success = true
            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form_checkout.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form_checkout.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>